import { Injectable } from '@angular/core';
import { HttpBackend, HttpContextToken, HttpEvent, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { RestangularHttp } from 'ngx-restangular';
import { AppSettings } from '../../app.settings';
import { TabStorageService } from '../tabstorage/tabstorage.service';
import { CredentialContext } from './credential-transition';

export const CREDENTIAL_REQUEST = new HttpContextToken<CredentialContext | null>(() => null);

/** Restangular uses HttpBackend directly. Capture context before its initial dispatch and retain it on replay. */
@Injectable()
export class CredentialRestangularHttp extends RestangularHttp {
  constructor(backend: HttpBackend) { super(backend); }

  request(request: HttpRequest<any>): Observable<HttpEvent<any>> {
    let context = request.context.get(CREDENTIAL_REQUEST);
    if (!context && this.sessionRequest(request)) {
      context = TabStorageService.credentials.capture();
      if (context.token) {
        request = request.clone({context: request.context.set(CREDENTIAL_REQUEST, context),
          headers: request.headers.set('Authorization', `Bearer ${context.token}`)});
      } else { context = null; }
    }
    if (context && !context.current()) { return throwError(new Error('Request session context changed')); }
    return super.request(request);
  }

  private sessionRequest(request: HttpRequest<any>): boolean {
    const url = request.url;
    if (request.headers.has('x-global-configs-auth') || url.includes('/auth') || url.includes('globalconfig.api')
      || url.includes('infra-mgmt.api') || url.includes('be-playground.api') || url.includes(AppSettings.getIntegrationEndpoint())) {
      return false;
    }
    if (!/^https?:\/\//i.test(url)) { return true; }
    try {
      const host = new URL(url).host;
      return host === new URL(AppSettings.getEndpoint()).host || host.endsWith('.api.wallit.app');
    } catch (_) { return url.startsWith(AppSettings.getEndpoint()); }
  }
}
